import { useEffect, useState } from "react";
import { useForm, Controller } from "react-hook-form";
import { DatePicker } from "rsuite";
import {
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Spinner,
} from "reactstrap";
import { callApi } from "../../../ApiHelper/ApiHelper";
import { apiUrl } from "../../../ApiHelper/ApiUrl";
import { toast } from "react-toastify";
import moment from "moment";
import ErrorMessage from "../../../components/comman/ErrorMessage";
import { formatAmount, printData } from "../../../utility/CommonFunctions";

const CreateTransactionModal = ({
  modal,
  toggle,
  invoiceDetail,
  GetInvoiceDetail,
  editData,
}) => {
  // console.log("invoiceDetail>>>>>.", invoiceDetail);

  const [isLoading, setIsLoading] = useState(false);
  const {
    register,
    handleSubmit,
    reset,
    setValue,
    watch,
    control,
    formState: { errors },
  } = useForm();
  const methodType = watch("paymentMethod");

  useEffect(() => {
    if (!editData) {
      reset({
        transactionDate: moment().format("YYYY-MM-DD"),
        utr: "",
        amount: "",
        type: "credit",
        paymentMethod: "",
        referenceName: "",
      });
    } else {
      reset({
        transactionDate: editData.transactionDate
          ? moment(editData.transactionDate).format("YYYY-MM-DD")
          : "",
        utr: editData.utr || "",
        amount: editData.amount || "",
        type: "credit",
        paymentMethod: editData.paymentMethod || "",
        referenceName: editData?.referenceName || "",
        bankName: editData?.bankName || "",
        accountNumber: editData?.accountNumber || "",
        accountHolderName: editData?.accountHolderName || "",
      });
    }
  }, [editData, reset]);

  let Balance =
    invoiceDetail?.grossAmount || invoiceDetail?.receivedAmount
      ? Math.round((+invoiceDetail?.grossAmount - +invoiceDetail?.receivedAmount) * 100) / 100
      : 0;
  // console.log("Balance=========>", Balance);

  const closeHandler = () => {
    toggle();
    reset();
  };

  const onSubmit = (data) => {
    const submitData = {
      ...(editData ? {} : { invoiceId: invoiceDetail?.id }),
      customerId: invoiceDetail?.workorder?.site?.customerId,
      transactionDate: data?.transactionDate,
      utr: data?.utr,
      amount: data?.amount,
      type: data?.paymentMethod === "roundOff" ? "roundOff" : "credit",
      paymentMethod: data?.paymentMethod,
      siteId: invoiceDetail?.workorder?.siteId,
      accountHolderName: data?.accountHolderName,
      accountNumber: data?.accountNumber,
      bankName: data?.bankName,
      referenceName: data?.referenceName,
    };
    // console.log("submitData>>>>.", submitData);

    const options = {
      method: "POST",
      data: submitData,
    };
    let API = editData
      ? apiUrl?.update_transaction + `?transactionId=${editData?.id}`
      : apiUrl?.create_transaction;
    setIsLoading(true);
    callApi(API, options).then((response) => {
      setIsLoading(false);
      if (response?.status === true) {
        toast.success(response?.message);
        GetInvoiceDetail();
        closeHandler();
      } else {
        toast.error(response?.message);
      }
    });
  };
  return (
    <Modal
      className="modal-dialog modal-xl transaction-modal"
      isOpen={modal}
      toggle={closeHandler}
      centered
    >
      {/* Modal Header */}
      <ModalHeader tag="h3" toggle={closeHandler}>
        {editData ? "Update" : "Create"} Transaction
      </ModalHeader>

      {/* Form Start */}
      <form onSubmit={handleSubmit(onSubmit)}>
        <ModalBody className="p-4">
          {/* Invoice Details */}
          <div className="table-responsive">
            <table className="table">
              <tbody>
                <tr>
                  <td className="fs-3">Invoice No.</td>
                  <td className="fs-3">
                    {invoiceDetail?.invoiceNumber || "--"}
                  </td>
                </tr>
                <tr>
                  <td className="fs-3">Total Bill</td>
                  <td className="fs-3">
                    {formatAmount(invoiceDetail?.grossAmount) || "--"}
                  </td>
                </tr>
                <tr>
                  <td className="fs-3">Received Amount</td>
                  <td className="fs-3">
                    {formatAmount(invoiceDetail?.receivedAmount) || 0}
                  </td>
                </tr>
                <tr>
                  <td className="fs-3">Balance</td>
                  <td
                    className={
                      invoiceDetail?.grossAmount > invoiceDetail?.receivedAmount
                        ? "text-danger fw-bold fs-3"
                        : "text-success fw-bold fs-3"
                    }
                  >
                    {formatAmount(Balance) || 0}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          {/* Transaction Form */}
          <div className="row mt-4">
            <div className="col-6">
              <div className="form-group mb-3">
                <label htmlFor="date" className="form-label">
                  Transaction Date <span className="text-danger">*</span>
                </label>
                <div className="input-group mb-3 DatePicker">
                  <Controller
                    name="transactionDate"
                    control={control}
                    rules={{
                      required: "Transaction Date is required",
                      validate: (value) => {
                        const invoiceDate = invoiceDetail?.createdAt ? moment(invoiceDetail?.createdAt).startOf('day') : null;
                        const today = moment().startOf('day');
                        const checkDate = moment(value).startOf('day');
                        if (invoiceDate && checkDate.isBefore(invoiceDate)) {
                          return `Date cannot be before invoice date (${invoiceDate.format("DD/MM/YYYY")})`;
                        }
                        if (checkDate.isAfter(today)) {
                          return "Future dates are not allowed";
                        }
                        return true;
                      }
                    }}
                    defaultValue={moment().format("YYYY-MM-DD")}
                    render={({ field }) => (
                      <DatePicker size="sm"
                        {...field}
                        format="dd/MM/yyyy"
                        oneTap
                        placeholder="dd/mm/yyyy"
                        style={{ width: "100%" }}
                        value={field.value ? new Date(field.value) : null}
                        onChange={(date) => {
                          field.onChange(date ? moment(date).format("YYYY-MM-DD") : "");
                        }}
                        shouldDisableDate={(date) => {
                          const invoiceDate = invoiceDetail?.createdAt ? moment(invoiceDetail?.createdAt).startOf('day') : null;
                          const today = moment().startOf('day');
                          const checkDate = moment(date).startOf('day');
                          return (invoiceDate && checkDate.isBefore(invoiceDate)) || checkDate.isAfter(today);
                        }}
                        container={() => document.querySelector('.transaction-modal .modal-content') || document.body}
                        cleanable={false}
                      />
                    )}
                  />
                </div>
                <ErrorMessage message={errors?.transactionDate?.message} />
              </div>
            </div>
            <div className="col-6">
              <label className="form-label">Payment Method</label>
              <select
                className="form-control"
                {...register("paymentMethod", {
                  required: "Payment Method is required",
                  onChange: (e) => {
                    const value = e.target.value;

                    // clear dependent fields
                    setValue("bankName", "");
                    setValue("accountHolderName", "");
                    setValue("accountNumber", "");
                    setValue("utrNumber", "");
                    setValue("referenceName", "");

                    // If you need to preserve the selected value, update it too
                    setValue("paymentMethod", value);
                  },
                })}
              >
                <option value="">Select Payment Method</option>
                <option value="Credit / Debit Card">Credit / Debit Card</option>
                <option value="UPI">UPI</option>
                <option value="NEFT">NEFT</option>
                <option value="RTGS">RTGS</option>
                <option value="IMPS">IMPS</option>
                <option value="Cash">Cash</option>
                <option value="roundOff">Round Off</option>

              </select>
              <ErrorMessage message={errors?.paymentMethod?.message} />
            </div>
            {methodType !== "Cash" && (
              <div className="col-6">
                <label className="form-label">UTR Number</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter UTR"
                  {...register("utr", {
                    required: "UTR Number is required",
                  })}
                />
                <ErrorMessage message={errors?.utr?.message} />
              </div>
            )}

            {(methodType === "NEFT" ||
              methodType === "RTGS" ||
              methodType === "IMPS") && (
                <>
                  <div className="col-6">
                    <div className="form-group mb-3">
                      <label htmlFor="bankName" className="form-label">
                        Bank Name
                      </label>
                      <div className="input-group mb-3 DatePicker">
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Bank Name"
                          {...register("bankName")}
                        />
                      </div>
                      <ErrorMessage message={errors?.bankName?.message} />
                    </div>
                  </div>
                  <div className="col-6">
                    <div className="form-group mb-3">
                      <label htmlFor="accountHolderName" className="form-label">
                        Account Holder Name <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="holderName"
                        placeholder="Account Holder Name"
                        {...register("accountHolderName", {
                          required: "Account holder name is required",
                        })}
                      />
                      <ErrorMessage
                        message={errors?.accountHolderName?.message}
                      />
                    </div>
                  </div>
                  <div className="col-6">
                    <div className="form-group mb-3">
                      <label htmlFor="accountNumber" className="form-label">
                        Account Number
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="accountNumber"
                        placeholder="Account Number"
                        {...register("accountNumber")}
                        onChange={(e) => {
                          e.target.value = e.target.value
                            .replace(/[^0-9.]/g, "") // Remove everything except numbers and dot
                            .replace(/^(\.)+/, "") // Prevent dot at the start
                            .replace(/(\..*)\./g, "$1"); // Prevent multiple dots
                        }}
                      />
                      <ErrorMessage message={errors?.accountNumber?.message} />
                    </div>
                  </div>
                </>
              )}
            {methodType === "Cash" && (
              <div className="col-6">
                <div className="form-group mb-3">
                  <label htmlFor="transactionAmount" className="form-label">
                    Reference Name <span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="holderName"
                    placeholder="Reference Name"
                    {...register("referenceName", {
                      required: "Reference Name is required",
                    })}
                  />
                  <ErrorMessage message={errors?.referenceName?.message} />
                </div>
              </div>
            )}
            <div className="col-6">
              <label className="form-label">
                Amount<span className="text-danger">*</span>
              </label>
              <input
                type="text"
                className="form-control"
                placeholder="Enter amount"
                step="any"
                max={Balance}
                {...register("amount", {
                  required: "Amount is required",
                  max: {
                    value: Balance,
                    message: `Amount must not exceed Balance Amount ${formatAmount(Balance) || "the allowed value"
                      }`,
                  },
                })}
                onChange={(e) => {
                  e.target.value = e.target.value
                    .replace(/[^0-9.]/g, "") // Remove everything except numbers and dot
                    .replace(/^(\.)+/, "") // Prevent dot at the start
                    .replace(/(\..*)\./g, "$1"); // Prevent multiple dots
                }}
              />
              <ErrorMessage message={errors?.amount?.message} />
            </div>
          </div>
        </ModalBody>

        {/* Modal Footer */}
        <ModalFooter>
          <button
            type="button"
            className="btn btn-secondary"
            onClick={closeHandler}
          >
            Close
          </button>
          <button
            type="submit"
            className="btn btn-danger"
            disabled={Balance === 0 || isLoading} // Disable if balance is 0 or loading
          >
            {isLoading ? <Spinner /> : editData ? "Update" : "Create"}
          </button>
        </ModalFooter>
      </form>
    </Modal>
  );
};

export default CreateTransactionModal;
